import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from './DatePicker';
import TimePicker from './TimePicker';

@autobind
/**
 *
 */
export default class ListView extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
  };

  static defaultProps = {
    onChange: () => {
    },
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    let value = props.value;

    if (value && !value.isEmpty()) {
      value = value.split(' ');
    } else {
      value = ['', ''];
    }

    this.state = {
      date: value[0],
      time: value[1],
    };
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (this.props.value !== np.value) {
      let value = np.value;

      if (value && !value.isEmpty()) {
        value = value.split(' ');
      } else {
        value = ['', ''];
      }

      this.setState({
        date: value[0],
        time: value[1],
      });
    }
  }

  /**
   *
   * @private
   */
  _onChange() {
    const {date, time} = this.state;

    if (date && time) {
      this.props.onChange(`${date} ${time}`);
    }
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const {date, time} = this.state;

    return (
      <div>
        <DatePicker
          value={date}
          onChange={(date) => this.setState({date}, this._onChange)}
        />
        <TimePicker
          value={time}
          onChange={(time) => this.setState({time}, this._onChange)}
        />
      </div>
    );
  }
}
